import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import LoadMask from '../../../../components/LoadMask';
import LuftCompanyForm from './LuftCompanyForm';

import { getUpdateCompanyUI, getRemoveCompanyUI } from '../../../../redux/selectors';
import { fetchCompanies, fetchUpdateCompany, fetchRemoveCompany, updateCompanyClear, removeCompanyClear } from '../../../../redux/admin-companies';

class EditCompanyModal extends Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(updateCompanyClear());
    dispatch(removeCompanyClear());
  }

    _submit = ({
      id, corporateName, cnpjList, luftBranch, logoFile, divisions,
    }) => {
      const { dispatch, onDismiss } = this.props;

      dispatch(fetchUpdateCompany(id, corporateName, cnpjList, luftBranch, logoFile, divisions)).then(
        () => {
          onDismiss();
          dispatch(fetchCompanies());
        },
        // reject
        () => {},
      );
    }

    _removeCompany = (companyData) => {
      const { dispatch, onDismiss } = this.props;
      dispatch(fetchRemoveCompany(companyData.id)).then(
        () => {
          onDismiss();
          dispatch(fetchCompanies());
        },
        // reject
        () => {},
      );
    }

    render() {
      const {
        companyData, removeCompanyUI, updateCompanyUI, onDismiss,
      } = this.props;

      return (
        <Modal
          title="Editar empresa"
          size="small"
          onBackdropClick={onDismiss}
        >
          <LuftCompanyForm
            errorMessage={updateCompanyUI.error || removeCompanyUI.error}
            companyData={companyData}
            onDismiss={onDismiss}
            onSubmit={this._submit}
            onRemove={this._removeCompany}
          />
          {
                (removeCompanyUI.isFetching || updateCompanyUI.isFetching) &&
                <LoadMask text={updateCompanyUI.isFetching ? 'Salvando...' : 'Removendo...'} />
            }
        </Modal>
      );
    }
}

function mapStateToProps(state) {
  return {
    updateCompanyUI: getUpdateCompanyUI(state),
    removeCompanyUI: getRemoveCompanyUI(state),
  };
}

export default connect(mapStateToProps)(EditCompanyModal);
